import React from "react";
import { Column } from "@ant-design/plots";
import { formatDataNumberToen, formatDataTimer } from "../../../helper/helper";
import styled from "styled-components";

const DashboardOverview = ({
  dataDashboard,
  yField,
  isHiddenContainer = false,
  width = 600,
}) => {
  const { data, xField, annotations } = dataDashboard;

  const config = {
    data: formatDataTimer(data) || [],
    xField: xField,
    yField: yField,
    columnWidthRatio: 0.8,
    yAxis: {
      label: {
        formatter: (v) => ` ${formatDataNumberToen(+v)}` ,
      },
    },
    tooltip: {
      formatter: (datum) => ({
        name: yField,
        value: `${formatDataNumberToen(+datum[yField])}`,
      }),
    },
    label: {
      position: "middle",
      style: {
        fill: "#FFFFFF",
        opacity: 0,
      },
      content: (originData) => {
        const val = formatDataNumberToen(originData[yField]);
        return val;
      },
    },
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
  };
  return (
    <Container
      className={`${!isHiddenContainer ? "container" : ""}`}
      width={width}
    >
      <div className="dash-board">
        <Column {...config} />
      </div>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  overflow-x: auto;

  .dash-board {
    min-width: ${(props) => props.width}px;
    overflow: auto;
  }
`;

export default DashboardOverview;
